import {newLogger} from "../../../core/utils/logger";
import 'lib/slick-carousel';

const logger = newLogger('Articles');

export function init() {
	const $section = $('#articles');
	$section.removeClass('before-slick-init');
	const $navSlider = $section.find('[rel=nav-slider]');
	const $slaveSlider = $section.find('[rel=slave-slider]');

	$navSlider.slick({
		arrows: false,
		variableWidth: true,
		// infinite: true,
		centerMode: true,
		focusOnSelect: true,
		asNavFor: $slaveSlider,
		responsive: [
			{
				breakpoint: 1160,
				settings: {
					slidesToShow: 3,
					centerMode: true,
					infinite: true,
					arrows: true
				}
			}
		]
	}).on('click11', '.slick-slide', function () {
		const index = $(this).data('slickIndex');
		$navSlider.slick('slickGoTo', index);
	}).on('afterChange11', function (e, s, index) {
		const category = $navSlider.find(`.slick-slide[data-slick-index=${index}] li`).data('category');
		setCategory(category);
	}).on('afterChange', () => {
		if (window.lazyLoader) {
			window.lazyLoader.update();
		}
	});

	$slaveSlider.slick({
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		asNavFor: $navSlider,
		__responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4
				}
			},
			{
				breakpoint: 938,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 750,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 489,
				settings: {
					slidesToShow: 1,
					centerMode: true,
				}
			}

		]
	});

	// const category = $navSlider.find(`.slick-slide[data-slick-index=0] li`).data('category');
	// setCategory(category);

	function setCategory(category) {
		logger.log('set category', category);
		$slaveSlider.slick('slickUnfilter');
		$slaveSlider.slick('slickFilter', `:has([data-category=${category}])`);
	}
}



// WEBPACK FOOTER //
// ./modules/landing/sections/articles.js